// extracted by mini-css-extract-plugin
export default {"otpRow":"PmAccessGate_otpRow__wSj+t"};